import { render, staticRenderFns } from "./batchChangePrice.vue?vue&type=template&id=667cb804&scoped=true"
import script from "./batchChangePrice.vue?vue&type=script&lang=js"
export * from "./batchChangePrice.vue?vue&type=script&lang=js"
import style0 from "./batchChangePrice.vue?vue&type=style&index=0&id=667cb804&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667cb804",
  null
  
)

export default component.exports